const INITIAL_STATE = {
  data: {},
  errors: {},
}
	
const getServiceOrders = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SERVICE_ORDERS_SUCCESSFULLY':
	  return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_SERVICE_ORDERS_FAILED':
	  return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
	
export default getServiceOrders;
	